<div
  class="popup"
  (keydown.escape)="onCancel()"
  tabindex="0"
>
  <div class="popup__box">
    @if (remainingTime()) {
      <div class="popup__timer-content">
        <div class="popup__timer">{{ formattedTime() }}</div>

        <mdcr-button
          class="icon"
          (click)="onCancel()"
          aria-label="Close"
          [iconPath]="SVG.closeGrey"
          [iconAlt]="'Close'"
        />
      </div>
    }

    <div class="popup__content">
      <div
        class="popup__line"
        [ngClass]="'popup__line--' + POPUPS[popupType()].color"
      ></div>
      <div class="popup__content-text">
        <div class="popup__header">
          <h3
            class="popup__header-title"
            [ngClass]="'popup__header-title--' + POPUPS[popupType()].color"
          >
            {{ POPUPS[popupType()].title }}
          </h3>

          @if (!remainingTime()) {
            <mdcr-button
              class="icon"
              (click)="onCancel()"
              aria-label="Close"
              [iconPath]="SVG.closeGrey"
              [iconAlt]="'Close'"
            />
          }
        </div>

        <p class="popup__text">
          {{ POPUPS[popupType()].text }}
        </p>
      </div>
    </div>

    @if (hasButtons()) {
      <div class="popup__actions">
        @if (hasSecondaryButton()) {
          <mdcr-button
            class="neutral-outlined medium"
            (buttonClick)="onSecondaryButtonClick()"
            [label]="POPUPS[popupType()].secondaryButton"
          />
        }

        <mdcr-button
          class="medium"
          [class.error-filled]="isErrorButton()"
          [class.neutral-filled]="!isErrorButton()"
          (buttonClick)="onButtonClick()"
          [label]="POPUPS[popupType()].button"
        />
      </div>
    }
  </div>
</div>
